<template>
    <div>
        <div v-if="hasAccessToChatBot">
            <li class="footer-link icon chat">
                <button @click="openChatModal" class="footer-link__button" v-html="$t('Footer.chat_with_us')"></button>
            </li>
        </div>
        <div v-if="!hasAccessToChatBot">
            <li class="footer-link icon chat" v-if="areStatisticsCookiesEnabled">
                <button @click="toggleChat" class="footer-link__button" v-html="$t('Footer.chat_with_us')"></button>
            </li>
            <li class="footer-link icon chat" v-else>
                <button @click="showHubSpotDisabledPopup" class="footer-link__button" v-html="$t('Footer.chat_with_us')"></button>
            </li>
        </div>
    </div>
</template>

<script>
import HubSpotChat from 'components/chatbot/customer_support/HubSpotChat.vue'
import HubspotDisabledPopup from 'components/cookieconsent/HubspotDisabledPopup.vue'
import hubSpotChatHelper from 'components/shared/mixins/hubSpotChatHelper'
import { mapGetters } from 'vuex'
import config from 'services/config'

export default {
    name: 'FooterHubspotChat',
    components: {HubSpotChat, HubspotDisabledPopup},
    mixins: [hubSpotChatHelper],
    computed: {
        ...mapGetters({
            isLoggedIn: 'isLoggedIn',
            getUserInfo: 'User/getUserInfo'
        }),
        hasAccessToChatBot () {
            return this.isLoggedIn && this.getUserInfo && this.getUserInfo.hasAccessToChat && config.chatBotNewUIEnabled
        }
    },
    methods: {
        async openChatModal () {
            await this.$store.dispatch('ChatBotCombo/setShowChatModal', true)
            if (this.currentChatMode === 'hubspot') {
                this.$store.dispatch('Hubspot/UnreadConversationCountChanged', 0)
            }
        },
        showHubSpotDisabledPopup () {
            this.$store.dispatch('Hubspot/showHubSpotDisabledPopup')
        }
    }
}
</script>

<style scoped lang="scss">
.footer-link {
    list-style: none;
    font-size: 1.6rem;
    position: relative;
    display: flex;
    align-items: center;

    &.icon {
        margin: 0 0 0 35px;

        &:before {
            font-family: 'icomoon';
            font-size: 2rem;
            position: absolute;
            margin: 0 0 0 -35px;
        }
    }

    &.chat:before {
        content: '\e94a';
    }

    &__button {
        text-decoration: none;
        color: $white;
        background: none;
        border: none;
        padding: 0;
        cursor: pointer;

        &:hover {
            text-decoration: underline;
            text-decoration-color: $gray_chateau;
        }
    }
}
</style>
